import type { InventoryItemNameRow } from '@/lib/api'

/** Category IDs that appear on at least one inventory row (non-null category_id). */
export function categoryIdsWithInventory(items: InventoryItemNameRow[]): Set<string> {
  const ids = new Set<string>()
  for (const row of items) {
    if (row.category_id) ids.add(row.category_id)
  }
  return ids
}

/** Keep only categories that have ≥1 inventory item. */
export function filterCategoriesWithInventory<T extends { category_id: string }>(
  categories: T[],
  inventoryItems: InventoryItemNameRow[]
): T[] {
  const ids = categoryIdsWithInventory(inventoryItems)
  return categories.filter((c) => ids.has(c.category_id))
}
